module.exports = __webpack_public_path__ + "img/logo-m2n.5d4fede0.svg";